
import { useState } from 'react';

const MarketplaceSection = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'Tout', nameAr: 'الكل', icon: 'ri-apps-line' },
    { id: 'food', name: 'Alimentation', nameAr: 'الطعام', icon: 'ri-restaurant-line' },
    { id: 'clothing', name: 'Vêtements', nameAr: 'الملابس', icon: 'ri-shirt-line' },
    { id: 'electronics', name: 'Électronique', nameAr: 'الإلكترونيات', icon: 'ri-smartphone-line' },
    { id: 'home', name: 'Maison', nameAr: 'المنزل', icon: 'ri-home-line' },
    { id: 'services', name: 'Services', nameAr: 'الخدمات', icon: 'ri-tools-line' }
  ];

  const products = [
    {
      id: 1,
      title: 'Couscous Traditionnel Marocain',
      titleAr: 'كسكس مغربي تقليدي',
      price: '15€',
      originalPrice: '20€',
      seller: 'Fatima B.',
      location: 'Rouen Centre',
      category: 'food',
      rating: 4.8,
      reviews: 24,
      image: 'https://public.readdy.ai/ai/img_res/926dc93d2f91c3bcb09877fd6d923b6d.jpg',
      badge: 'Fait Maison',
      badgeColor: 'bg-green-500'
    },
    {
      id: 2,
      title: 'Djellaba Homme Élégante',
      titleAr: 'جلابة رجالية أنيقة',
      price: '45€',
      originalPrice: '65€',
      seller: 'Ahmed M.',
      location: 'Sotteville',
      category: 'clothing',
      rating: 4.9,
      reviews: 18,
      image: 'https://readdy.ai/api/search-image?query=Elegant%20traditional%20Moroccan%20djellaba%20for%20men%20in%20rich%20fabric%2C%20beautiful%20embroidery%20details%2C%20professional%20product%20photography%2C%20cultural%20clothing%20representing%20quality%20traditional%20wear&width=400&height=300&seq=djellaba-1&orientation=landscape',
      badge: 'Neuf',
      badgeColor: 'bg-blue-500'
    },
    {
      id: 3,
      title: 'Cours d\'Arabe Particuliers',
      titleAr: 'دروس عربية خاصة',
      price: '20€/h',
      originalPrice: '25€/h',
      seller: 'Professeur Youssef',
      location: 'Mont-Riboudet',
      category: 'services',
      rating: 5.0,
      reviews: 32,
      image: 'https://readdy.ai/api/search-image?query=Arabic%20language%20teacher%20giving%20private%20lesson%20with%20books%20and%20writing%20materials%2C%20educational%20setting%2C%20professional%20tutoring%20environment%20representing%20quality%20language%20instruction&width=400&height=300&seq=arabic-lesson-1&orientation=landscape',
      badge: 'Certifié',
      badgeColor: 'bg-purple-500'
    },
    {
      id: 4,
      title: 'Tajine en Terre Cuite',
      titleAr: 'طاجين من الطين',
      price: '25€',
      originalPrice: '35€',
      seller: 'Khadija A.',
      location: 'Grammont',
      category: 'home',
      rating: 4.7,
      reviews: 15,
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Moroccan%20clay%20tagine%20pot%20with%20beautiful%20geometric%20patterns%2C%20authentic%20cookware%2C%20rustic%20kitchen%20setting%20representing%20quality%20traditional%20cooking%20utensils&width=400&height=300&seq=tajine-1&orientation=landscape',
      badge: 'Artisanal',
      badgeColor: 'bg-orange-500'
    },
    {
      id: 5,
      title: 'Smartphone Samsung Galaxy',
      titleAr: 'هاتف سامسونج غالاكسي',
      price: '180€',
      originalPrice: '220€',
      seller: 'Karim L.',
      location: 'Darnétal',
      category: 'electronics',
      rating: 4.6,
      reviews: 12,
      image: 'https://readdy.ai/api/search-image?query=Modern%20Samsung%20Galaxy%20smartphone%20in%20excellent%20condition%2C%20clean%20product%20photography%2C%20technology%20device%20representing%20quality%20used%20electronics&width=400&height=300&seq=smartphone-1&orientation=landscape',
      badge: 'Bon État',
      badgeColor: 'bg-teal-500'
    },
    {
      id: 6,
      title: 'Pâtisseries Orientales',
      titleAr: 'حلويات شرقية',
      price: '12€/kg',
      originalPrice: '15€/kg',
      seller: 'Pâtisserie Nour',
      location: 'Rouen Centre',
      category: 'food',
      rating: 4.9,
      reviews: 45,
      image: 'https://readdy.ai/api/search-image?query=Assorted%20Middle%20Eastern%20pastries%20and%20sweets%20beautifully%20arranged%2C%20baklava%20and%20oriental%20desserts%2C%20professional%20bakery%20presentation%20representing%20quality%20traditional%20sweets&width=400&height=300&seq=pastries-1&orientation=landscape',
      badge: 'Frais du Jour',
      badgeColor: 'bg-pink-500'
    }
  ];

  const filteredProducts = activeCategory === 'all' 
    ? products 
    : products.filter(product => product.category === activeCategory);

  return (
    <section className="py-20 bg-gradient-to-br from-emerald-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center shadow-lg">
              <i className="ri-store-line text-white text-2xl"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold">
              <span className="bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                Marketplace Communautaire
              </span>
            </h2>
          </div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-4">
            Achetez et vendez entre membres de la communauté maghrébine de Rouen
          </p>
          <p className="text-lg text-emerald-600 font-medium">
            السوق المجتمعي - تسوق وبيع بين أفراد الجالية المغاربية في روان
          </p>
        </div>

        {/* Categories Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`flex items-center gap-2 px-6 py-3 rounded-full font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                activeCategory === category.id
                  ? 'bg-emerald-600 text-white shadow-lg scale-105'
                  : 'bg-white text-gray-600 hover:bg-emerald-50 hover:text-emerald-600 shadow-md'
              }`}
            >
              <i className={`${category.icon} text-lg`}></i>
              <span>{category.name}</span>
              <span className="text-sm opacity-75">({category.nameAr})</span>
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-product-shop>
          {filteredProducts.map((product) => (
            <div key={product.id} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 overflow-hidden">
              {/* Product Image */}
              <div className="relative">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className={`absolute top-4 left-4 ${product.badgeColor} text-white px-3 py-1 rounded-full text-sm font-medium`}>
                  {product.badge}
                </div>
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full p-2 cursor-pointer hover:bg-white transition-colors">
                  <i className="ri-heart-line text-gray-600 hover:text-red-500 transition-colors"></i>
                </div>
              </div>

              {/* Product Info */}
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-1 line-clamp-2">
                  {product.title}
                </h3>
                <p className="text-sm text-emerald-600 mb-3 font-medium">
                  {product.titleAr}
                </p>

                {/* Price */}
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-2xl font-bold text-emerald-600">
                    {product.price}
                  </span>
                  {product.originalPrice && (
                    <span className="text-lg text-gray-400 line-through">
                      {product.originalPrice}
                    </span>
                  )}
                </div>

                {/* Rating */}
                <div className="flex items-center gap-2 mb-3">
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-${i < Math.floor(product.rating) ? 'fill' : 'line'} text-yellow-400 text-sm`}
                      ></i>
                    ))}
                  </div>
                  <span className="text-sm text-gray-600">
                    {product.rating} ({product.reviews} avis)
                  </span>
                </div>

                {/* Seller Info */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center">
                      <i className="ri-user-line text-emerald-600 text-sm"></i>
                    </div>
                    <span className="text-sm text-gray-600">{product.seller}</span>
                  </div>
                  <div className="flex items-center gap-1 text-sm text-gray-500">
                    <i className="ri-map-pin-line"></i>
                    <span>{product.location}</span>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-2">
                  <button className="flex-1 bg-emerald-600 text-white py-2 px-4 rounded-lg hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap font-medium">
                    Acheter
                  </button>
                  <button className="bg-emerald-100 text-emerald-600 py-2 px-4 rounded-lg hover:bg-emerald-200 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-message-line"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-emerald-600 to-teal-600 rounded-3xl p-8 md:p-12 text-center text-white">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-3xl md:text-4xl font-bold mb-4">
              Rejoignez Notre Marketplace
            </h3>
            <p className="text-xl mb-2 opacity-90">
              Vendez vos produits et services à la communauté
            </p>
            <p className="text-lg mb-8 opacity-75">
              انضم إلى السوق وبيع منتجاتك وخدماتك للمجتمع
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-emerald-600 px-8 py-4 rounded-xl font-semibold hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-add-line mr-2"></i>
                Vendre un Produit
              </button>
              <button className="bg-emerald-700 text-white px-8 py-4 rounded-xl font-semibold hover:bg-emerald-800 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-eye-line mr-2"></i>
                Voir Tous les Produits
              </button>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16">
          {[
            { number: '500+', label: 'Produits', labelAr: 'منتج', icon: 'ri-shopping-bag-line' },
            { number: '200+', label: 'Vendeurs', labelAr: 'بائع', icon: 'ri-user-line' },
            { number: '1000+', label: 'Ventes', labelAr: 'عملية بيع', icon: 'ri-money-euro-circle-line' },
            { number: '4.8/5', label: 'Satisfaction', labelAr: 'رضا العملاء', icon: 'ri-star-fill' }
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-white rounded-2xl shadow-lg flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-emerald-600 text-2xl`}></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">{stat.number}</div>
              <div className="text-gray-600 font-medium">{stat.label}</div>
              <div className="text-emerald-600 text-sm">{stat.labelAr}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MarketplaceSection;
